import { Fragment, useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { Card, CardBody, CardHeader } from "reactstrap"
import { getColor } from "helpers/utilities"

const FooterLeft = ({ data, t }) => {
  const [totalSampleDaily, setTotalSampleDaily] = useState({})

  useEffect(() => {
    setTotalSampleDaily(data?.totalSampleDaily || {})
  }, [data])

  return (
    <Fragment>
      <Card className="mb-2" style={{ height: "200px" }}>
        <CardHeader
          style={{
            textAlign: "center",
            background: "#fff",
            paddingBottom: 0,
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 600 }}>Tổng số mẫu</div>
        </CardHeader>
        <CardBody style={{ paddingTop: 0 }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <div className="">
                <h5 className="font-size-14">
                  Trong ngày{" "}
                  <span className="float-end">
                    {totalSampleDaily?.totalSamples || 0}
                  </span>
                </h5>
              </div>
            </li>
            {totalSampleDaily?.totalSampleByService?.map((item, index) => (
              <li
                key={index}
                className="list-group-item"
                style={{ paddingTop: 0, paddingBottom: 0 }}
              >
                <div className="py-2 d-flex" style={{ alignItems: 'center', gap: '5px' }}>
                  <div style={{ width: '20%' }}>
                    <span className="font-size-13">
                      {item.serviceTypeName}
                    </span>
                  </div>
                  <div className="progress animated-progess progress-sm" style={{ width: '70%' }}>
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${item.percent}%`,
                        background: getColor(index),
                      }}
                      aria-valuenow={`${item.percent}%`}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div style={{ width: '10%' }}>
                    <span className="float-end">{item.percent}%</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </CardBody>
      </Card>
    </Fragment>
  )
}

export default withTranslation(["generalDashboard", "message"])(FooterLeft)
